<template>
  <div id="register-setting-page">
    <div class="page-name">
      <div class="page-title">Setup Privilege</div>
    </div>
    <div class="page-container">
      <b-card class="w-100">
        <privilege-table
          :data="privileges"
          :category="category"
          :paginate="paginate"
          :onSetActive="onSetActive"
          :onUpdatePaginate="onUpdatePaginate"
          :onUpdateLimit="onUpdateLimit"
          :onUpdateSort="onUpdateSort"
          :onDeleteData="onDeleteData"
        />
      </b-card>
      <br />
    </div>
  </div>
</template>

<script>
import PrivilegeTable from '@/components/tables/PrivilegeTable'
import { mapActions } from 'vuex'
import { ActionFetch } from '@/store/actionTypes'

export default {
  components: {
    'privilege-table': PrivilegeTable,
  },
  data: () => ({
    enable: true,
    privileges: [],
    category: [],
    paginate: {
      limit: 10,
      page: 1,
      totalPage: 1,
      totalRow: '',
    },
  }),
  methods: {
    ...mapActions({
      getCategory: ActionFetch.GUFAMILY.CATEGORY.LIST,
      getList: ActionFetch.GUFAMILY.PRIVILEGE.LIST,
      createData: ActionFetch.GUFAMILY.PRIVILEGE.CREATE,
      updateData: ActionFetch.GUFAMILY.PRIVILEGE.UPDATE,
      updateSort: ActionFetch.GUFAMILY.PRIVILEGE.UPDATESORT,
      deleteData: ActionFetch.GUFAMILY.PRIVILEGE.DELETE,
    }),
    onDeleteData($data) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure ?`, {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0 justify-center',
          centered: true,
          okOnly: true,
        })
        .then(($conRes) => {
          if ($conRes) {
            this.deleteData($data.id).then(($res) => {
              if ($res.success) {
                this.fetchList(this.paginate.page)
              }
            })
          }
        })
    },
    onUpdatePaginate($paginate) {
      this.paginate.page = $paginate

      this.fetchList($paginate)
    },
    onUpdateSort($data) {
      this.updateSort($data).then(($res) => {
        if ($res.success) {
          this.fetchList(this.paginate.page)
        }
      })
    },
    onUpdateLimit($limit) {
      this.paginate.limit = $limit
      this.paginate.page = 1
      this.fetchList()
    },
    onSetActive($data, $source) {
      $source.status = $data.value ? 'Active' : 'Inactive'

      let dataSave = {
        id: $source.id,
        status: $source.status,
      }

      this.updateData(dataSave)
    },
    fetchList($page = 1) {
      const payload = {
        orderBy: 'orderNum',
        direction: 'asc',
        limit: this.paginate.limit,
        page: $page,
      }

      this.getList(payload).then(($res) => {
        if ($res.success) {
          this.privileges = $res.data.map(($data) => {
            if ($data.endDate) {
              const endDate = new Date($data.endDate)
              let dd = endDate.getDate()
              let mm = endDate.getMonth() + 1
              let yy = endDate.getFullYear()
              const currentEndDate = new Date(`${yy}-${mm}-${dd} 23:59:59`)
              const currentDate = new Date()

              if (currentEndDate < currentDate) {
                $data.status = 'Inactive'
              }
            }

            return $data
          })
          this.paginate.totalPage = $res.dataLimit
            ? $res.dataLimit.totalPage
            : 1
          this.paginate.totalRow = $res.dataLimit ? $res.dataLimit.totalData : 0
        }
      })
    },
    fetchCategoryList() {
      this.getCategory().then(($res) => {
        if ($res.success) {
          this.category = $res.data
        }
      })
    },
  },
  created() {
    this.fetchList()
    this.fetchCategoryList()
  },
}
</script>

<style>
td {
  vertical-align: middle !important;
  font-size: 14px;
}
</style>
